import React, { useState } from 'react';
import { observer } from 'mobx-react';
import './operator.css';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../translations/format-message';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import dummyImage from '../../assets/Images/wire.jpg'; // Placeholder for the image source
import { Tabs, Tab } from 'react-bootstrap';

const OperatorImageAssign = (props: any) => {
  const [quantity, setQuantity] = useState<number>(1);

  const handleDecrement = () => {
    setQuantity((prev) => Math.max(0, prev - 1));
  };

  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setQuantity(value);
    }
  };
  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="task_name" />
              </h1>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li
                title={formatMessage('process_wise_chart')}
                className="process-chart"
              >
                <a
                  className="btn btn-secondary"
                  href={RoutesConstants.OperatorListDetail}
                >
                  <FormattedMessage id="back" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
          <div className="card tray-card">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th className="card-title">
                    <FormattedMessage id="Tray ID" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="highlight ">
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
                <tr>
                  <td className="card-data">98765432109876543210</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-8 col-lg-6 col-xl-7">
          <div className="card picture-card">
            <Tabs
              defaultActiveKey="image"
              id="picture-tab"
            >
              <Tab
                eventKey="image"
                title="image"
              >
                <img
                  src={dummyImage}
                  alt=""
                  className="img-fluid"
                />
              </Tab>
              <Tab
                eventKey="pdf"
                title="pdf"
              >
                PDF
              </Tab>
            </Tabs>
          </div>
        </div>
        <div className="col-12 col-lg-3 col-xl-3">
          <div className="card card-body tray-header mb-3">
            <div className="d-flex gap-2 flex-wrap align-items-center justify-content-between">
              <h2>Process Name</h2>
              <div className="card-title d-flex align-items-center justify-content-end gap-2"></div>
            </div>
          </div>

          <div className="card tray-data">
            <div className="row g-3 tray-data-header">
              <div className="col-12">
                <p className="small text-muted">Product ID</p>
                <p className="text-dark">98765432109876543210</p>
              </div>
              <div className="col-12">
                <p className="small text-muted">Kishu</p>
                <p className="text-dark">98765432109876543210</p>
              </div>
              <div className="col-12">
                <p className="small text-muted">Katashiki</p>
                <p className="text-dark">98765432109876543210</p>
              </div>
            </div>

            <table className="table table-bordered print-table">
              <thead>
                <tr>
                  <th className="card-title">
                    <FormattedMessage id="Print Content" />
                  </th>
                  <th className="card-title">
                    <FormattedMessage id="Position" />
                  </th>
                  <th className="card-title">
                    <FormattedMessage id="Print" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>

                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="card-data">
                    XP374FN <br />
                    <span className="text-primary">Teplar template</span>
                  </td>
                  <td className="card-data">1</td>
                  <td className="card-data">
                    <button className="btn btn-sm btn-primary">
                      <svg
                        version="1.1"
                        id="fi_446991"
                        width="28"
                        height="28"
                        fill="currentColor"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911
			c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z"
                            ></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775
			H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614
			c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306
			c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708
			H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801
			z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443
			c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(OperatorImageAssign);
